import { render, staticRenderFns } from "./Jsonblock.vue?vue&type=template&id=5d66001c&scoped=true"
import script from "./Jsonblock.vue?vue&type=script&lang=js"
export * from "./Jsonblock.vue?vue&type=script&lang=js"
import style0 from "./Jsonblock.vue?vue&type=style&index=0&id=5d66001c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66001c",
  null
  
)

export default component.exports